'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import H1 from 'UIComponents/elements/headings/H1';
import UIImage from 'UIComponents/image/UIImage';
import Branding from 'MeetingsBase/models/Branding';
import { getPrimaryButtonStyle, getPrimaryButtonHoverStyle } from 'MeetingsLib/utils/color';
import BookingFormField from 'MeetingsLib/components/input/BookingFormField';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { fetchPublicAvailabilityInfoForOwner as fetchBookInfoForOwner, fetchMeetingsUserForContactOwnerPrioritization as fetchMeetingsUser } from 'MeetingsLib/redux/actions/BookActions';
import { getStagedPrefillEmail } from 'MeetingsLib/selectors/PrefillSelectors';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import CompanyLogo, { COMPANY_LOGO_USE } from 'MeetingsLib/components/decorative/CompanyLogo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EmailForm extends Component {
  constructor(props) {
    super(props);
    this.getEmailIsValid = () => {
      const {
        email
      } = this.state;
      return Boolean(email && EmailAddressPattern.test(email));
    };
    this.onEmailChange = (fieldName, email) => {
      this.setState({
        email
      });
    };
    this.onMouseEnter = () => {
      this.setState({
        buttonHover: true
      });
    };
    this.onMouseLeave = () => {
      this.setState({
        buttonHover: false
      });
    };
    this.getValidation = () => {
      if (this.getEmailIsValid()) {
        return false;
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.details.errorHelper.email"
      });
    };
    this.getClassNames = () => {
      return 'email-form p-all-5' + (this.props.compact ? " compact" : "");
    };
    this.handleEmailSubmit = e => {
      e.preventDefault();
      const {
        email
      } = this.state;
      const {
        setEmailForm,
        fetchPublicAvailabilityInfoForOwner,
        fetchMeetingsUserForContactOwnerPrioritization,
        meetingChangeId
      } = this.props;
      setEmailForm(email);
      if (meetingChangeId) {
        fetchPublicAvailabilityInfoForOwner({
          email,
          meetingChangeId
        });
      } else {
        fetchPublicAvailabilityInfoForOwner({
          email
        });
      }
      fetchMeetingsUserForContactOwnerPrioritization(email);
    };
    this.renderButton = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      const style = this.state.buttonHover ? getPrimaryButtonHoverStyle(primaryColor) : getPrimaryButtonStyle(primaryColor);
      const isValid = this.getEmailIsValid();
      return /*#__PURE__*/_jsx("div", {
        className: "text-center m-top-5",
        children: /*#__PURE__*/_jsx(PreviewContext.Consumer, {
          children: isPreview => /*#__PURE__*/_jsx(UIButton, {
            style: style,
            use: "primary",
            disabled: !isValid,
            onClick: !isPreview && this.handleEmailSubmit,
            size: "medium",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.button"
            })
          })
        })
      });
    };
    this.renderAvatar = () => {
      const {
        useCompanyLogo,
        logoUrl,
        branding
      } = this.props;
      if (!useCompanyLogo && !logoUrl) {
        return /*#__PURE__*/_jsx(UIIllustration, {
          name: "meetings",
          width: "60%"
        });
      } else if (useCompanyLogo) {
        return /*#__PURE__*/_jsx("div", {
          className: "text-center m-top-4 m-x-14",
          children: /*#__PURE__*/_jsx(CompanyLogo, {
            branding: branding,
            use: COMPANY_LOGO_USE.EMAIL_FORM,
            heightOverride: "200px"
          })
        });
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: "text-center m-top-4",
          children: /*#__PURE__*/_jsx(UIImage, {
            src: logoUrl,
            shape: "circle",
            style: {
              width: '200px',
              height: '200px',
              margin: 'auto'
            }
          })
        });
      }
    };
    this.state = {
      email: props.prefillEmail || '',
      buttonHover: false
    };
  }
  render() {
    const {
      branding: {
        primaryColor
      },
      title,
      description,
      EmailFormMarker
    } = this.props;
    const classes = this.getClassNames();
    const color = primaryColor;
    const fieldLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailForm.placeholder"
    });
    return /*#__PURE__*/_jsx(UIFlex, {
      justify: "around",
      className: classes,
      style: {
        borderColor: color
      },
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          maxWidth: '350px'
        },
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-center m-top-4",
          children: [this.renderAvatar(), /*#__PURE__*/_jsx(H1, {
            className: "m-y-2",
            children: title || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.header"
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "m-bottom-4",
            children: description || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "emailForm.text"
            })
          })]
        }), /*#__PURE__*/_jsx(BookingFormField, {
          fieldName: "email",
          fieldLabel: fieldLabel,
          validation: this.getValidation(),
          fieldValue: this.state.email,
          isRequired: true,
          setFormValue: this.onEmailChange,
          autocomplete: "on"
        }), this.renderButton(), /*#__PURE__*/_jsx(EmailFormMarker, {})]
      })
    });
  }
}
EmailForm.propTypes = {
  compact: PropTypes.bool,
  logoUrl: PropTypes.string,
  useCompanyLogo: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  meetingChangeId: PropTypes.string,
  setEmailForm: PropTypes.func.isRequired,
  fetchPublicAvailabilityInfoForOwner: PropTypes.func.isRequired,
  fetchMeetingsUserForContactOwnerPrioritization: PropTypes.func.isRequired,
  branding: PropTypes.instanceOf(Branding).isRequired,
  EmailFormMarker: PropTypes.func.isRequired,
  prefillEmail: PropTypes.string
};
export default connect(state => ({
  prefillEmail: getStagedPrefillEmail(state)
}), Object.assign({}, FormActions, {
  fetchPublicAvailabilityInfoForOwner: fetchBookInfoForOwner,
  fetchMeetingsUserForContactOwnerPrioritization: fetchMeetingsUser
}))(EmailForm);